import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { CogIcon } from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';
import NavColumn from './NavColumn';

function NavigationDesktopDropdownFull(props) {
  const { sections } = props;

  return (
    <Popover className="relative">
      <PopoverButton className="flex max-w-xs items-center rounded-full text-black text-sm hover:text-rcprimary-400 focus:outline-hidden">
        <CogIcon className="h-6 w-6" aria-hidden="true" />
      </PopoverButton>

      <PopoverPanel
        transition
        className="-right-10 absolute z-[999] mx-4 mt-4 flex w-screen max-w-max translate-x-1 bg-transparent px-4 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-leave:duration-150 data-enter:ease-out data-leave:ease-in"
      >
        <div className="grid grid-cols-3 gap-x-6 rounded-3xl border border-rcprimary-100/30 bg-gray-800 p-12 shadow-none outline-white/10 sm:gap-x-32">
          {sections.map((section) => (
            <NavColumn
              key={section.title}
              title={section.title}
              links={section.links}
            />
          ))}
        </div>
      </PopoverPanel>
    </Popover>
  );
}

NavigationDesktopDropdownFull.propTypes = {
  sections: PropTypes.array.isRequired,
};

export default NavigationDesktopDropdownFull;
